import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GoogleAnalytics = () => {
  const location = useLocation();

  //   useEffect(() => {
  //   console.log('Google Analytics loaded:', !!window.gtag);
  //   console.log('Current page:', location.pathname);
  // }, [location]);

  useEffect(() => {
    // Проверяваме дали вече е заредено (за да не се дублира)
    if (window.gtag) return;

    // Зареждане на Google Analytics скрипт
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=G-7N6HZLCVGE";
    script1.async = true;
    document.head.appendChild(script1);

    // Инициализиране на gtag функцията
    const script2 = document.createElement("script");
    script2.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-7N6HZLCVGE');
    `;
    document.head.appendChild(script2);
  }, []);

  // Проследяване на всяка промяна на страницата
  useEffect(() => {
    if (window.gtag && location.pathname) {
      window.gtag("event", "page_view", {
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null; // Този компонент не рендерира нищо
};

export default GoogleAnalytics;
